export default "__VITE_ASSET__DAQhCceO__"